module.exports = {
      id: "gztrending-usage",
      viewBox: "0 0 18.806 24.145",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#gztrending",
      toString: function () {
        return this.url;
      }
    }